import { SingleValuePanel, type SingleValuePanelProps } from '@/components/shared';

export type UserSingleValuePanelProps = SingleValuePanelProps;

export function UserSingleValuePanel(props: UserSingleValuePanelProps) {
  return <SingleValuePanel {...props} />;
}
